import { useContext } from 'react';
import { ActivitiesContext, ActivitiesContextData } from '.';

export function useActivitiesContext(): ActivitiesContextData {
  return useContext(ActivitiesContext);
}
